import React, { useId } from "react";

interface RadioOption {
  value: string;
  label?: string;
  description?: string;
}

interface RadioGroupProps {
  label: string;
  options: RadioOption[];
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const RadioGroup: React.FC<RadioGroupProps> = ({ label, options, value, onChange, disabled = false }) => {
  const groupId = useId();
  const labelSt: React.CSSProperties = { fontSize: "12px", fontWeight: 500, color: "var(--t2, #5A6178)", fontFamily: "var(--font-primary, DM Sans, sans-serif)", lineHeight: "16px", marginBottom: "4px" };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "6px", width: "100%" }}>
      {label && <span style={labelSt}>{label}</span>}
      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        {options.map((opt) => {
          const isSelected = value === opt.value;
          const optId = `${groupId}-${opt.value}`;
          return (
            <label key={opt.value} htmlFor={optId} style={{ display: "flex", alignItems: "flex-start", gap: "10px", cursor: disabled ? "not-allowed" : "pointer", padding: "8px 12px", borderRadius: "8px", border: isSelected ? "1px solid var(--accent, #D23A3B)" : "1px solid var(--card-border, #E2E5EC)", backgroundColor: isSelected ? "var(--accent-soft, rgba(210, 58, 59, 0.04))" : "var(--surface, #FFFFFF)", transition: "all 0.15s ease" }}>
              <div style={{ width: "18px", height: "18px", borderRadius: "50%", border: isSelected ? "2px solid var(--accent, #D23A3B)" : "2px solid var(--card-border, #E2E5EC)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, marginTop: "1px", transition: "border-color 0.15s ease" }}>
                {isSelected && <div style={{ width: "8px", height: "8px", borderRadius: "50%", backgroundColor: "var(--accent, #D23A3B)" }} />}
              </div>
              <input type="radio" id={optId} name={groupId} value={opt.value} checked={isSelected} onChange={() => onChange(opt.value)} disabled={disabled} style={{ position: "absolute", opacity: 0, width: 0, height: 0 }} />
              <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                <span style={{ fontSize: "13px", fontWeight: 500, color: "var(--t1, #1A1D2E)", fontFamily: "var(--font-primary, DM Sans, sans-serif)" }}>{opt.label}</span>
                {opt.description && <span style={{ fontSize: "12px", color: "var(--t3, #9CA3B8)", fontFamily: "var(--font-primary, DM Sans, sans-serif)", lineHeight: "1.4" }}>{opt.description}</span>}
              </div>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default RadioGroup;
